import CanvasObject from "./canvasObject";

export default class Food extends CanvasObject {
  colour = "green";
}
